import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import { styled } from '@classify/react-core-components/styles';
const Root = styled('div')(({
  theme: {
    palette
  }
}) => ({
  border: `1px solid ${palette.layout.surface.border}`,
  display: 'inline-flex',
  width: 40,
  height: 40,
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center'
}));
const UvpIcon = t0 => {
  const $ = _c(2);
  const {
    icon: Icon
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Root><Icon /></Root>;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default UvpIcon;